import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { RootState } from '../../models/RootState';
import './ExchMatchOddsTable.scss';
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Tooltip,
  Button,
  Drawer,
} from '@material-ui/core';
import { IonIcon } from '@ionic/react';
import moment from 'moment';
import { PlaceBetRequest } from '../../models/BsData';
import ExchOddBtn from '../ExchOddButton/ExchOddButton';
import { UserBet } from '../../models/UserBet';
import InfoImg from '../../assets/images/sportsbook/info.svg';
import TimerImg from '../../assets/images/sportsbook/delay.svg';
import JercyIcon from '../../assets/images/sportsbook/icons/horse-jercy.png';
import { SelectedObj } from '../../models/ExchangeSportsState';
import { EventDTO } from '../../models/common/EventDTO';
import {
  MatchOddsDTO,
  MatchOddsRunnerDTO,
} from '../../models/common/MatchOddsDTO';
import MarketTermsCondi from '../../components/MarketTermsCondi/MarketTermsCondi';
import Modal from '../../components/Modal/Modal';
import {
  getAllMarketsByEvent,
  addExchangeBet,
  getSecondaryMatchOddsByEvent,
  getCurrencyTypeFromToken,
  addToMultiMarket,
  removeToMultiMarket,
  checkIncludeMultiMarket,
} from '../../store';
import API from '../../api';
import SVLS_API from '../../api-services/svls-api';
import { CURRENCY_TYPE_FACTOR } from '../../constants/CurrencyTypeFactor';
import { formatTime, ThousandFormatter } from '../../util/stringUtil';
import { useHistory } from 'react-router-dom';
import { useMarketLocalState } from '../../hooks/storageHook';
import multipin from '../../assets/images/common/multipin.svg';
import removemultipin from '../../assets/images/common/removemultimarket.svg';
import { CloseOutlined } from '@material-ui/icons';
import { isMobile } from 'react-device-detect';
import { useInterval } from '../../hooks/useInterval';
type OddsInfoMsg = {
  launch: boolean;
  oddsType: string;
  eventTypeID: string;
};

type CashoutInfo = {
  selectionId: string;
  betType: any;
  oddValue: number;
  stakeAmount: number;
};

type StoreProps = {
  eventData: EventDTO;
  bets: PlaceBetRequest[];
  openBets: UserBet[];
  addExchangeBet: (data: PlaceBetRequest) => void;
  selectedEventType: SelectedObj;
  secondaryMatchOdds: MatchOddsDTO[];
  getFormattedMinLimit: (num: number) => string;
  getFormattedMaxLimit: (num: number) => string;
  loggedIn?: boolean;
  isMultiMarket?: boolean;
  exposureMap: any;
  fetchEvent: (
    sportId: string,
    competitionId: string,
    eventId: string,
    marketTime: string
  ) => void;
};

const MatchOddsTable: React.FC<StoreProps> = (props) => {
  const {
    eventData,
    bets,
    openBets,
    addExchangeBet,
    selectedEventType,
    secondaryMatchOdds,
    loggedIn,
    isMultiMarket,
    exposureMap,
    fetchEvent,
  } = props;
  const history = useHistory();
  const [multiMarketData, setMultiMarketData] = useMarketLocalState();
  const [matchOddsData, setMatchOddsData] = useState<MatchOddsDTO>();
  //todo: remove commented market limits code if everything works fine
  const [marketLimits, setMarketLimits] = useState<any>({});
  const [selectedRow, setSelectedRow] = useState<string>('');
  const [infoDilalog, setInfoDialog] = useState<OddsInfoMsg>({
    launch: false,
    oddsType: null,
    eventTypeID: null,
  });
  const [open, setOpen] = useState<String[]>([]);
  const disabledStatus = ['suspended', 'closed', 'suspended-manually'];
  const cFactor = CURRENCY_TYPE_FACTOR[getCurrencyTypeFromToken()];

  const tableFields = [
    {
      key: 'teamName',
      Label: 'Market',
      className: 'market-name-cell-head',
      align: 'left',
    },
    {
      key: 'Back',
      Label: 'Back',
      className: 'odds-cell-head',
      align: 'right',
    },
    {
      key: 'Lay',
      Label: 'Lay',
      className: 'odds-cell-head',
      align: 'left',
    },
  ];

  // useEffect(() => {
  //   if (eventData) {
  //     const marketId = eventData?.matchOdds?.marketId;
  //     const interval = setInterval(() => {
  //       fetchBetLimits(marketId);
  //     }, 5000);
  //     return () => clearInterval(interval);
  //   }

  //   if (secondaryMatchOdds) {
  //     for (let market of secondaryMatchOdds) {
  //       const interval = setInterval(() => {
  //         fetchBetLimits(market.marketId, market.marketName);
  //       }, 5000);
  //       return () => clearInterval(interval);
  //     }
  //   }
  // }, []);

  // const fetchBetLimits = async (marketId?: string, marketName?: string) => {
  //   try {
  //     const payload = {
  //       sportId: eventData.sportId,
  //       competitionId: eventData.competitionId,
  //       eventId: eventData.eventId,
  //       marketType: 'MATCH_ODDS',
  //       outcomeDesc: marketName ? marketName : 'Match Odds',
  //       marketId: marketId ? marketId : eventData.marketId,
  //       sessionId: '-1',
  //       mcategory: "ALL",
  //     };

  //     let response;
  //     if (sessionStorage.getItem('jwt_token')) {
  //       response = await API.post('/bs/fetch-market-limits', payload, {
  //         headers: {
  //           Authorization: sessionStorage.getItem('jwt_token'),
  //         },
  //       });
  //     } else {
  //       response = await API.post('/bs/fetch-market-limits', payload);
  //     }

  //     if (response.status === 200 && response.data.success) {
  //       let limits = marketLimits;

  //       limits[marketId ? marketId : eventData.marketId] = {
  //         min: response.data.limits.minStake,
  //         max: response.data.limits.maxStake,
  //         oddLimt: response.data.limits.maxOdd,
  //       };

  //       // setMarketLimits((marketLimits) => {
  //       //   return {
  //       //     ...marketLimits,
  //       //     ...limits,
  //       //   };
  //       // });
  //     }
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  useEffect(() => {
    if (eventData !== null) {
      setMatchOddsData(eventData.matchOdds);
    }
  }, [eventData]);

  const getOpenBetsPL = (
    marketId: string,
    marketName: string,
    runner: MatchOddsRunnerDTO
  ) => {
    let returns = null;

    if (exposureMap && exposureMap?.[`${marketId}:${marketName}`]) {
      for (let rn of exposureMap[`${marketId}:${marketName}`]) {
        if (rn.runnerId === runner.runnerId) {
          return rn?.userRisk / cFactor;
        }
      }
    }
  };

  const getOpenBetsPLInArray = (
    marketId: string,
    marketName: string,
    runner: MatchOddsRunnerDTO
  ) => {
    let pl = getOpenBetsPL(marketId, marketName, runner);
    return pl ? [pl] : [];
  };

  const getTotalPL = (
    marketId: string,
    marketName: string,
    runner: MatchOddsRunnerDTO
  ) => {
    let returns = null;
    const mBetslipBets = bets.filter(
      (b) =>
        // (b.marketName === 'Match Odds' || b.marketName === 'Goal Markets') &&
        b.marketId === marketId && b.amount && b.amount > 0
    );

    if (mBetslipBets.length > 0) {
      returns = getOpenBetsPL(marketId, marketName, runner);
      for (let bet of mBetslipBets) {
        const plVal = bet.oddValue * bet.amount - bet.amount;
        if (bet.betType === 'BACK') {
          if (bet.outcomeId === runner.runnerId) {
            returns ? (returns += plVal) : (returns = plVal);
          } else {
            returns ? (returns -= bet.amount) : (returns = 0 - bet.amount);
          }
        } else if (bet.betType === 'LAY') {
          if (bet.outcomeId !== runner.runnerId) {
            returns ? (returns += bet.amount) : (returns = bet.amount);
          } else {
            returns ? (returns -= plVal) : (returns = 0 - plVal);
          }
        }
      }
    }
    return [returns];
  };

  const getMarketStatus = (marketTime: Date) => {
    let duration = moment.duration(moment(marketTime).diff(moment()));
    return duration.asMinutes() < 10 && duration.asMinutes() > 0
      ? 'OPEN'
      : 'SUSPENDED';
  };
  const handleMultiMarket = (
    competitionId,
    eventId,
    marketId,
    providerName,
    sportId,
    isAdd = true
  ) => {
    if (loggedIn) {
      if (isAdd) {
        addToMultiMarket(
          competitionId,
          eventId,
          marketId,
          providerName,
          sportId
        );
        marketId &&
          setMultiMarketData((prevState) => {
            return [
              ...prevState,
              {
                competitionId,
                eventId,
                marketId,
                providerName,
                sportId,
              },
            ];
          });
      } else {
        removeToMultiMarket(eventId, marketId);
        marketId &&
          setMultiMarketData((prevState) => {
            let data = [...prevState];
            const index = data?.findIndex(
              (itm) => itm.eventId === eventId && itm.marketId === marketId
            );
            index > -1 && data.splice(index, 1);
            return [...data];
          });
      }
    } else {
      history.push('/login');
    }
  };

  const CashOut = async (matchOddsData: MatchOddsDTO) => {
    try {
      const response = await SVLS_API.get(
        `/order/v2/orders/sports/${eventData.sportId}/events/${eventData.eventId}/markets/${matchOddsData.marketId}/cash-out-bet:probability`,
        {
          headers: {
            Authorization: sessionStorage.getItem('jwt_token'),
          },
        }
      );

      if (response.status === 200) {
        const betDetails: CashoutInfo = response.data;

        // Add bet to betslip
        addExchangeBet({
          sportId: eventData.sportId,
          seriesId: eventData.competitionId,
          seriesName: eventData.competitionName,
          eventId: eventData.eventId,
          eventName: eventData.eventName,
          eventDate: eventData.openDate,
          marketId: matchOddsData.marketId,
          marketName: matchOddsData.marketName,
          marketType: 'MO',
          outcomeId: betDetails?.selectionId,
          betType: betDetails?.betType === 0 ? 'BACK' : 'LAY',
          oddValue: +betDetails?.oddValue.toFixed(2),
          // initialOddValue: +betDetails.oddValue.toFixed(2),
          amount: +(betDetails?.stakeAmount / cFactor).toFixed(2),
          outcomeDesc: getOutcomeId(
            betDetails?.selectionId,
            matchOddsData.runners
          ),
          sessionPrice: -1,
          srEventId: eventData.eventId,
          srSeriesId: eventData.competitionId,
          srSportId: eventData.sportId,
          oddLimt: matchOddsData?.marketLimits?.maxOdd.toString(),
          mcategory: 'ALL',
        });
      }
    } catch (err) {
      console.log('Something went wrong');
    }
  };

  const getOutcomeId = (selectionId: string, runners: MatchOddsRunnerDTO[]) => {
    for (let mo of runners) {
      if (mo.runnerId === selectionId) {
        return mo.runnerName;
      }
    }
  };

  const isHaveCashOut = (matchOddsData: MatchOddsDTO) => {
    if (matchOddsData?.runners?.length !== 2) {
      return false;
    }

    if (openBets?.length === 0) {
      return false;
    }

    // Get the market specific bets
    const op = openBets?.filter((bet: UserBet) => {
      return bet.marketId === matchOddsData.marketId;
    });

    return op?.length > 0 ? true : false;
  };

  return (
    <>
      <div className="matchodds-table-ctn">
        <div className="matchodds-table-content table-ctn">
          {matchOddsData?.runners?.length > 0 &&
          matchOddsData.status.toLowerCase() !== 'closed' ? (
            <>
              {!isMultiMarket ||
              checkIncludeMultiMarket(
                multiMarketData,
                matchOddsData.marketId,
                eventData.eventId
              ) ? (
                <TableContainer component={Paper}>
                  <Table className="matchodds-table">
                    <TableHead>
                      <TableRow>
                        <TableCell colSpan={3}>
                          <div className="market-name-cell-head-ctn">
                            <span className="market-name">
                              {!checkIncludeMultiMarket(
                                multiMarketData,
                                matchOddsData.marketId,
                                eventData?.eventId
                              ) ? (
                                <Tooltip
                                  title="Add To Multi Markets "
                                  placement="left-start"
                                >
                                  <img
                                    // color="primary"
                                    className="multi-add-icon"
                                    src={multipin}
                                    alt="multimarket"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      multiMarketData?.length < 10 &&
                                        handleMultiMarket(
                                          eventData?.competitionId,
                                          eventData?.eventId,
                                          matchOddsData.marketId,
                                          eventData?.providerName,
                                          eventData?.sportId,
                                          true
                                        );
                                    }}
                                  />
                                </Tooltip>
                              ) : (
                                <Tooltip
                                  title="Remove From Multi Markets"
                                  placement="left-start"
                                >
                                  <img
                                    className="multi-remove-icon"
                                    src={removemultipin}
                                    alt="multimarket"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleMultiMarket(
                                        eventData?.competitionId,
                                        eventData?.eventId,
                                        matchOddsData.marketId,
                                        eventData?.providerName,
                                        eventData?.sportId,
                                        false
                                      );
                                    }}
                                  />
                                </Tooltip>
                              )}{' '}
                              Match Odds{' '}
                              <span className="event-name">
                                {isMultiMarket && !isMobile
                                  ? eventData?.eventName
                                  : null}
                              </span>
                              <IonIcon
                                className="info-img"
                                onClick={() =>
                                  setInfoDialog({
                                    launch: true,
                                    oddsType: 'MatchOdds',
                                    eventTypeID: selectedEventType.id,
                                  })
                                }
                                src={InfoImg}
                              />
                              <IonIcon className="timer-img" src={TimerImg} />
                              <span className="delay-details">5S</span>
                            </span>
                            <span className="bet-limits-section web-view">
                              MIN:
                              {ThousandFormatter(
                                eventData?.matchOdds?.marketLimits
                                  ? eventData?.matchOdds?.marketLimits
                                      ?.minStake / cFactor
                                  : 100
                              )}{' '}
                              MAX:
                              {eventData?.matchOdds?.marketLimits?.maxStake %
                                1000 ===
                              0
                                ? ThousandFormatter(
                                    eventData?.matchOdds?.marketLimits
                                      ? eventData?.matchOdds?.marketLimits
                                          ?.maxStake / cFactor
                                      : 5000
                                  )
                                : eventData?.matchOdds?.marketLimits
                                ? eventData?.matchOdds?.marketLimits?.maxStake /
                                  cFactor
                                : 5000}
                              {/* {ThousandFormatter(
                                eventData?.matchOdds?.marketLimits
                                  ? eventData?.matchOdds?.marketLimits.?.maxStake /
                                  cFactor
                                  : 5000
                              )} */}
                            </span>
                            <span className="bet-limits-section mob-view">
                              <div>
                                MIN:
                                {ThousandFormatter(
                                  eventData?.matchOdds?.marketLimits
                                    ? eventData?.matchOdds?.marketLimits
                                        ?.minStake / cFactor
                                    : 100
                                )}{' '}
                              </div>
                              <div>
                                MAX:
                                {eventData?.matchOdds?.marketLimits?.maxStake %
                                  1000 ===
                                0
                                  ? ThousandFormatter(
                                      eventData?.matchOdds?.marketLimits
                                        ? eventData?.matchOdds?.marketLimits
                                            ?.maxStake / cFactor
                                        : 5000
                                    )
                                  : eventData?.matchOdds?.marketLimits
                                  ? eventData?.matchOdds?.marketLimits
                                      ?.maxStake / cFactor
                                  : 5000}
                              </div>
                            </span>
                          </div>
                        </TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      <TableRow className="header-row">
                        {tableFields.map((tF, index) => (
                          <TableCell
                            key={tF.key + index}
                            align={
                              tF.align === 'left'
                                ? 'left'
                                : tF.align === 'right'
                                ? 'right'
                                : 'center'
                            }
                            colSpan={1}
                            className={tF.className}
                          >
                            {tF.key === 'lay' || 'back' ? (
                              <div className="cashout-option">
                                <div className={tF.key.toLowerCase() + '-odd'}>
                                  {tF.Label}
                                </div>

                                {isHaveCashOut(matchOddsData) &&
                                tF.Label.toLowerCase() === 'market' ? (
                                  <Button
                                    size="small"
                                    color="primary"
                                    variant="contained"
                                    className="btn"
                                    disabled={
                                      disabledStatus.includes(
                                        matchOddsData.status.toLowerCase()
                                      ) || matchOddsData.suspend === true
                                    }
                                    onClick={() => CashOut(matchOddsData)}
                                  >
                                    Cashout
                                  </Button>
                                ) : null}
                              </div>
                            ) : (
                              <>
                                <span>{tF.Label} </span>
                              </>
                            )}
                          </TableCell>
                        ))}
                      </TableRow>
                      {matchOddsData ? (
                        <>
                          {matchOddsData.runners
                            .filter(
                              (runner, idx) =>
                                runner?.status.toLowerCase() !== 'loser'
                            )
                            .map((runner, index) => (
                              <MatchOddsRow
                                minStake={
                                  matchOddsData?.marketLimits
                                    ? matchOddsData?.marketLimits?.minStake /
                                      cFactor
                                    : 0
                                }
                                maxStake={
                                  matchOddsData?.marketLimits
                                    ? matchOddsData?.marketLimits?.maxStake /
                                      cFactor
                                    : 0
                                }
                                eventData={eventData}
                                marketName="Match Odds"
                                // marketLimits={marketLimits}
                                matchOddsData={matchOddsData}
                                runner={runner}
                                getOpenBetsPL={getOpenBetsPLInArray}
                                getTotalPL={getTotalPL}
                                disabledStatus={disabledStatus}
                                addExchangeBet={addExchangeBet}
                                bets={bets}
                                selectedRow={selectedRow}
                                setSelectedRow={setSelectedRow}
                                open={open}
                                setOpen={setOpen}
                                index={index}
                              />
                            ))}
                        </>
                      ) : (
                        <>
                          <TableRow>
                            <TableCell colSpan={3}>
                              <div className="fm-table-msg-text">
                                No Match Odds for this event
                              </div>
                            </TableCell>
                          </TableRow>
                        </>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : null}
            </>
          ) : null}

          {secondaryMatchOdds.map((moData, idx) => (
            <>
              {moData.status.toLowerCase() !== 'closed' ? (
                <>
                  {!isMultiMarket ||
                  checkIncludeMultiMarket(
                    multiMarketData,
                    moData.marketId,
                    eventData.eventId
                  ) ? (
                    <TableContainer component={Paper}>
                      <Table className="matchodds-table sec-mo-tbl">
                        <TableHead>
                          <TableRow>
                            <TableCell colSpan={3}>
                              <div className="market-name-cell-head-ctn">
                                <span className="market-name">
                                  {!checkIncludeMultiMarket(
                                    multiMarketData,
                                    moData.marketId,
                                    eventData?.eventId
                                  ) ? (
                                    <Tooltip
                                      title="Add To Multi Markets "
                                      placement="left-start"
                                    >
                                      <img
                                        className="multi-add-icon"
                                        src={multipin}
                                        alt="multimarket"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          multiMarketData?.length < 10 &&
                                            handleMultiMarket(
                                              eventData?.competitionId,
                                              eventData?.eventId,
                                              moData.marketId,
                                              eventData?.providerName,
                                              eventData?.sportId,
                                              true
                                            );
                                        }}
                                      />
                                    </Tooltip>
                                  ) : (
                                    <Tooltip
                                      title="Remove From Multi Markets"
                                      placement="left-start"
                                    >
                                      <img
                                        className="multi-remove-icon"
                                        src={removemultipin}
                                        alt="multimarket"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleMultiMarket(
                                            eventData?.competitionId,
                                            eventData?.eventId,
                                            moData.marketId,
                                            eventData?.providerName,
                                            eventData?.sportId,
                                            false
                                          );
                                        }}
                                      />
                                    </Tooltip>
                                  )}
                                  {moData.marketName?.length > 15 && isMobile
                                    ? moData.marketName?.slice(0, 14) + '..'
                                    : moData.marketName}{' '}
                                  <span className="event-name">
                                    {isMultiMarket && !isMobile
                                      ? eventData?.eventName
                                      : null}
                                  </span>
                                  {!['7', '4339'].includes(
                                    selectedEventType?.id
                                  ) ? (
                                    <>
                                      <IonIcon
                                        className="info-img"
                                        onClick={() =>
                                          setInfoDialog({
                                            launch: true,
                                            oddsType: 'MatchOdds',
                                            eventTypeID: selectedEventType.id,
                                          })
                                        }
                                        src={InfoImg}
                                      />{' '}
                                      <IonIcon
                                        className="timer-img"
                                        src={TimerImg}
                                      />
                                      <span className="delay-details">5S </span>
                                    </>
                                  ) : null}
                                  {['7', '4339'].includes(
                                    selectedEventType?.id
                                  ) ? (
                                    <span className="market-start-time">
                                      {formatTime(moData?.marketTime)}
                                    </span>
                                  ) : null}
                                </span>
                                <span>
                                  {['7', '4339'].includes(
                                    selectedEventType?.id
                                  ) ? (
                                    <span
                                      className={
                                        getMarketStatus(moData.marketTime) ===
                                        'OPEN'
                                          ? 'profit web-view'
                                          : 'loss web-view'
                                      }
                                    >
                                      {' '}
                                      {getMarketStatus(moData.marketTime)}
                                    </span>
                                  ) : null}
                                </span>
                                <span className="bet-limits-section web-view">
                                  MIN:
                                  {moData?.marketLimits
                                    ? ThousandFormatter(
                                        moData?.marketLimits?.minStake / cFactor
                                      )
                                    : 100}{' '}
                                  MAX:
                                  {moData?.marketLimits
                                    ? ThousandFormatter(
                                        moData?.marketLimits?.maxStake / cFactor
                                      )
                                    : 5000}
                                </span>
                                <span className="bet-limits-section mob-view">
                                  <div>
                                    MIN:
                                    {moData?.marketLimits
                                      ? ThousandFormatter(
                                          moData?.marketLimits?.minStake /
                                            cFactor
                                        )
                                      : 100}{' '}
                                  </div>
                                  <div>
                                    MAX:
                                    {moData?.marketLimits
                                      ? ThousandFormatter(
                                          moData?.marketLimits?.maxStake /
                                            cFactor
                                        )
                                      : 5000}
                                  </div>
                                </span>
                              </div>
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <TableRow className="header-row">
                            {tableFields.map((tF, index) => (
                              <TableCell
                                key={tF.key + index}
                                align={
                                  tF.align === 'left'
                                    ? 'left'
                                    : tF.align === 'right'
                                    ? 'right'
                                    : 'center'
                                }
                                colSpan={1}
                                className={tF.className}
                              >
                                {tF.key === 'lay' || 'back' ? (
                                  <div className="cashout-option">
                                    <div
                                      className={tF.key.toLowerCase() + '-odd'}
                                    >
                                      {tF.Label}

                                      {index === 0 &&
                                      ['7', '4339'].includes(
                                        selectedEventType?.id
                                      ) ? (
                                        <label
                                          className={
                                            getMarketStatus(
                                              moData.marketTime
                                            ) === 'OPEN'
                                              ? 'profit mob-view'
                                              : 'loss mob-view'
                                          }
                                        >
                                          {' '}
                                          {getMarketStatus(moData.marketTime)}
                                        </label>
                                      ) : null}
                                    </div>

                                    {isHaveCashOut(moData) &&
                                    tF.Label.toLowerCase() === 'market' ? (
                                      <Button
                                        size="small"
                                        color="primary"
                                        variant="contained"
                                        className="btn"
                                        disabled={
                                          disabledStatus.includes(
                                            moData.status.toLowerCase()
                                          ) || moData.suspend === true
                                        }
                                        onClick={() => CashOut(moData)}
                                      >
                                        Cashout
                                      </Button>
                                    ) : null}
                                  </div>
                                ) : (
                                  <>
                                    <span>{tF.Label} </span>
                                  </>
                                )}
                              </TableCell>
                            ))}
                          </TableRow>

                          {moData ? (
                            <>
                              {moData.runners
                                .filter(
                                  (runner, idx) =>
                                    runner?.status.toLowerCase() !== 'loser'
                                )
                                .map((runner, index) => (
                                  <MatchOddsRow
                                    minStake={
                                      moData?.marketLimits
                                        ? moData?.marketLimits?.minStake /
                                          cFactor
                                        : 0
                                    }
                                    maxStake={
                                      moData?.marketLimits
                                        ? moData?.marketLimits?.maxStake /
                                          cFactor
                                        : 0
                                    }
                                    eventData={eventData}
                                    marketName={moData?.marketName}
                                    // marketLimits={marketLimits}
                                    matchOddsData={moData}
                                    runner={runner}
                                    getOpenBetsPL={getOpenBetsPLInArray}
                                    getTotalPL={getTotalPL}
                                    disabledStatus={disabledStatus}
                                    addExchangeBet={addExchangeBet}
                                    bets={bets}
                                    selectedRow={selectedRow}
                                    setSelectedRow={setSelectedRow}
                                  />
                                ))}
                            </>
                          ) : (
                            <>
                              <TableRow>
                                <TableCell colSpan={3}>
                                  <div className="fm-table-msg-text">
                                    No Goal markets for this event
                                  </div>
                                </TableCell>
                              </TableRow>
                            </>
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  ) : null}
                </>
              ) : null}
            </>
          ))}

          <Drawer
            anchor={'right'}
            open={infoDilalog.launch}
            onClose={() =>
              setInfoDialog({
                launch: false,
                oddsType: null,
                eventTypeID: null,
              })
            }
            className="light-bg-title game-rules-drawer web-view"
            title="Rules"
            // size="md"
          >
            <div className="game-rules-header">
              <div className="game-rules-title">Game Rules</div>
              <div
                className="game-rules-close cursor"
                onClick={() =>
                  setInfoDialog({
                    launch: false,
                    oddsType: null,
                    eventTypeID: null,
                  })
                }
              >
                <CloseOutlined />
              </div>
            </div>
            <MarketTermsCondi
              oddsType={infoDilalog.oddsType}
              eventTypeID={infoDilalog.eventTypeID}
            />
          </Drawer>
          <Drawer
            anchor={'bottom'}
            open={infoDilalog.launch}
            onClose={() =>
              setInfoDialog({
                launch: false,
                oddsType: null,
                eventTypeID: null,
              })
            }
            className="light-bg-title game-rules-drawer mob-view"
            title="Rules"
            // size="md"
          >
            <div className="game-rules-header">
              <div className="game-rules-title">Game Rules</div>
              <div
                className="game-rules-close cursor"
                onClick={() =>
                  setInfoDialog({
                    launch: false,
                    oddsType: null,
                    eventTypeID: null,
                  })
                }
              >
                <CloseOutlined />
              </div>
            </div>
            <MarketTermsCondi
              oddsType={infoDilalog.oddsType}
              eventTypeID={infoDilalog.eventTypeID}
            />
          </Drawer>
        </div>
      </div>
    </>
  );
};

type MatchOddsRowProps = {
  minStake: any;
  maxStake: any;
  eventData: EventDTO;
  marketName: string;
  matchOddsData: MatchOddsDTO;
  runner: MatchOddsRunnerDTO;
  // marketLimits: any;
  getOpenBetsPL: (
    marketId: string,
    marketName: string,
    runner: MatchOddsRunnerDTO,
    type: string
  ) => number[];
  getTotalPL: (
    marketId: string,
    marketName: string,
    runner: MatchOddsRunnerDTO
  ) => number[];
  disabledStatus: string[];
  addExchangeBet: (data: PlaceBetRequest) => void;
  bets: PlaceBetRequest[];
  selectedRow: string;
  setSelectedRow: (data) => void;
  open?: String[];
  setOpen?: (data) => void;
  index?: number;
};

const MatchOddsRow: React.FC<MatchOddsRowProps> = (props) => {
  const {
    eventData,
    marketName,
    // marketLimits,
    matchOddsData,
    runner,
    getOpenBetsPL,
    getTotalPL,
    disabledStatus,
    addExchangeBet,
    minStake,
    maxStake,
    bets,
    selectedRow,
    setSelectedRow,
  } = props;

  const isOddDisable = (
    eventData: EventDTO,
    status: string,
    suspend: boolean,
    betType: string,
    odd: number,
    marketTime?: Date
  ) => {
    if (disabledStatus.includes(status.toLowerCase()) || suspend === true)
      return true;

    if (matchOddsData?.marketLimits?.maxOdd < odd) return true;

    // BBL CUP
    if (matchOddsData?.marketName.toLowerCase().includes('winner'))
      return false;

    if (['7', '4339'].includes(eventData.sportId)) {
      if (betType === 'lay') return true;

      let duration = moment.duration(moment(marketTime).diff(moment()));
      return duration.asMinutes() < 10 && duration.asMinutes() > 0
        ? false
        : true;
    }

    return moment(eventData.openDate).diff(moment(),'seconds') < 0 
    ? false
    : true;
  };  

  return (
    <TableRow>
      <TableCell className="team-name-cell">
        {eventData.sportId === '7' ? (
          <div className="horseracing-ctn">
            <div className="item1">
              <span className="list-item11">{runner.clothNumber}</span>
              <span className="list-item1">({runner.stallDraw})</span>
            </div>
            <div className="horseracing-img">
              <img
                src={runner?.runnerIcon}
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null; // prevents looping
                  currentTarget.src = JercyIcon;
                }}
                className="runner-img"
              />
            </div>

            <div className="runner-section">
              <div className="runner-name">{runner.runnerName}</div>

              <div className="runner-desc">
                <ul className="runner-desc-list">
                  <li className="list-item">
                    <span className="label">J: </span>
                    {runner?.jockeyName ? runner?.jockeyName : '-'}
                  </li>
                  {/* <li className="list-item">
                    <span className="label">Trainer: </span>
                    {runner?.trainerName ? runner?.trainerName : '-'}
                  </li> */}
                  <li className="list-item">
                    <span className="label">Age: </span>
                    {runner?.runnerAge ? runner?.runnerAge : '-'}
                  </li>
                </ul>
              </div>
            </div>
            {getOpenBetsPL(
              matchOddsData.marketId,
              matchOddsData.marketName,
              runner,
              'array'
            ).map((ret) =>
              ret !== null ? (
                <div className="profit-loss-box">
                  <span className={ret >= 0 ? 'profit' : 'loss'}>
                    {ret > 0
                      ? '+' + Number(ret).toFixed(2)
                      : Number(ret).toFixed(2)}
                  </span>
                </div>
              ) : null
            )}
          </div>
        ) : (
          <div className="team">
            {runner.runnerName}
            {getOpenBetsPL(
              matchOddsData.marketId,
              matchOddsData.marketName,
              runner,
              'array'
            ).map((ret) =>
              ret !== null ? (
                <span className={ret >= 0 ? 'profit' : 'loss'}>
                  {ret > 0
                    ? '+' + Number(ret).toFixed(2)
                    : Number(ret).toFixed(2)}
                </span>
              ) : null
            )}
          </div>
        )}
        {getTotalPL(
          matchOddsData.marketId,
          matchOddsData.marketName,
          runner
        ).map((ret) =>
          ret !== null ? (
            <div className="profit-loss-box">
              <span className={ret >= 0 ? 'profit' : 'loss'}>
                {ret > 0
                  ? '+' + Number(ret).toFixed(2)
                  : Number(ret).toFixed(2)}
              </span>
            </div>
          ) : null
        )}
      </TableCell>

      <TableCell className="odds-cell">
        <div className="odds-block web-view back-odds-block">
          {runner.backPrices?.length > 0 ? (
            runner.backPrices.map((odds, idx) => (
              <ExchOddBtn
                mainValue={odds?.price}
                subValue={odds.size}
                showSubValueinKformat={true}
                oddType="back-odd"
                valueType="matchOdds"
                oddsSet={[
                  runner.backPrices[0] ? runner.backPrices[0]?.price : 0,
                  runner.backPrices[1] ? runner.backPrices[1]?.price : 0,
                  runner.backPrices[2] ? runner.backPrices[2]?.price : 0,
                ]}
                key={idx}
                disable={isOddDisable(
                  eventData,
                  matchOddsData.status.toLowerCase(),
                  matchOddsData.suspend,
                  'back',
                  odds.price,
                  matchOddsData.marketTime
                )}
                // disable={
                //   disabledStatus.includes(matchOddsData.status.toLowerCase()) ||
                //   moment(eventData?.openDate).diff(moment(), 'minutes') >
                //     60 * 24 * 2 ||
                //   matchOddsData?.marketLimits?.maxOdd < odds?.price
                // }
                onClick={() => {
                  if (
                    moment(eventData?.openDate).diff(moment(), 'hour') <= 24 ||
                    eventData?.status === 'IN_PLAY' ||
                    disabledStatus.includes(
                      matchOddsData.status.toLowerCase()
                    ) ||
                    matchOddsData.suspend === true ||
                    !['7', '4339'].includes(eventData.sportId)
                  ) {
                    setSelectedRow(runner.runnerId + marketName + 'MO');
                    addExchangeBet({
                      sportId: eventData.sportId,
                      seriesId: eventData.competitionId,
                      seriesName: eventData.competitionName,
                      eventId: eventData.eventId,
                      eventName: eventData.eventName,
                      eventDate: eventData.openDate,
                      marketId: matchOddsData.marketId,
                      marketName: marketName,
                      marketType: 'MO',
                      outcomeId: runner.runnerId,
                      outcomeDesc: runner.runnerName,
                      betType: 'BACK',
                      amount: 0,
                      oddValue: odds?.price,
                      oddSize: odds.size,
                      sessionPrice: -1,
                      srEventId: eventData.eventId,
                      srSeriesId: eventData.competitionId,
                      srSportId: eventData.sportId,
                      minStake: minStake,
                      maxStake: maxStake,
                      oddLimt: matchOddsData?.marketLimits?.maxOdd.toString(),
                      mcategory: 'ALL',
                    });
                  }
                }}
              />
            ))
          ) : (
            <></>
          )}
        </div>
        <div className="odds-block mob-view">
          <ExchOddBtn
            mainValue={runner.backPrices[0]?.price}
            subValue={runner.backPrices[0]?.size}
            showSubValueinKformat={true}
            oddType="back-odd"
            valueType="matchOdds"
            disable={isOddDisable(
              eventData,
              matchOddsData.status.toLowerCase(),
              matchOddsData.suspend,
              'back',
              runner.backPrices[0]?.price,
              matchOddsData.marketTime
            )}
            onClick={() => {
              if (
                moment(eventData?.openDate).diff(moment(), 'hour') <= 24 ||
                eventData?.status === 'IN_PLAY' ||
                disabledStatus.includes(matchOddsData.status.toLowerCase()) ||
                matchOddsData.suspend === true ||
                !['7', '4339'].includes(eventData.sportId)
              ) {
                setSelectedRow(runner.runnerId + marketName + 'MO');
                addExchangeBet({
                  sportId: eventData.sportId,
                  seriesId: eventData.competitionId,
                  seriesName: eventData.competitionName,
                  eventId: eventData.eventId,
                  eventName: eventData.eventName,
                  eventDate: eventData.openDate,
                  marketId: matchOddsData.marketId,
                  marketName: marketName,
                  marketType: 'MO',
                  outcomeId: runner.runnerId,
                  outcomeDesc: runner.runnerName,
                  betType: 'BACK',
                  amount: 0,
                  oddValue: runner.backPrices[0].price,
                  oddSize: runner.backPrices[0].size,
                  sessionPrice: -1,
                  srEventId: eventData.eventId,
                  srSeriesId: eventData.competitionId,
                  srSportId: eventData.sportId,
                  minStake: minStake,
                  maxStake: maxStake,
                  oddLimt: matchOddsData?.marketLimits?.maxOdd.toString(),
                  mcategory: 'ALL',
                });
              }
            }}
          />
        </div>
      </TableCell>

      <TableCell className="odds-cell">
        <div className="odds-block web-view">
          {runner.layPrices?.length > 0 ? (
            runner.layPrices.map((odds, idx) => (
              <ExchOddBtn
                mainValue={
                  ['7', '4339'].includes(eventData.sportId) ? 0 : odds?.price
                }
                subValue={odds.size}
                showSubValueinKformat={true}
                oddType="lay-odd"
                valueType="matchOdds"
                oddsSet={[
                  runner.layPrices[0] ? runner.layPrices[0]?.price : 0,
                  runner.layPrices[1] ? runner.layPrices[1]?.price : 0,
                  runner.layPrices[2] ? runner.layPrices[2]?.price : 0,
                ]}
                key={idx}
                disable={isOddDisable(
                  eventData,
                  matchOddsData.status.toLowerCase(),
                  matchOddsData.suspend,
                  'lay',
                  odds.price
                )}
                onClick={() => {
                  if (
                    moment(eventData?.openDate).diff(moment(), 'hour') <= 24 ||
                    eventData?.status === 'IN_PLAY' ||
                    disabledStatus.includes(
                      matchOddsData.status.toLowerCase()
                    ) ||
                    matchOddsData.suspend === true ||
                    !['7', '4339'].includes(eventData.sportId)
                  ) {
                    setSelectedRow(runner.runnerId + marketName + 'MO');
                    addExchangeBet({
                      sportId: eventData.sportId,
                      seriesId: eventData.competitionId,
                      seriesName: eventData.competitionName,
                      eventId: eventData.eventId,
                      eventName: eventData.eventName,
                      eventDate: eventData.openDate,
                      marketId: matchOddsData.marketId,
                      marketName: marketName,
                      marketType: 'MO',
                      outcomeId: runner.runnerId,
                      outcomeDesc: runner.runnerName,
                      betType: 'LAY',
                      amount: 0,
                      oddValue: odds?.price,
                      oddSize: odds.size,
                      sessionPrice: -1,
                      srEventId: eventData.eventId,
                      srSeriesId: eventData.competitionId,
                      srSportId: eventData.sportId,
                      minStake: minStake,
                      maxStake: maxStake,
                      oddLimt: matchOddsData?.marketLimits?.maxOdd.toString(),
                      mcategory: 'ALL',
                    });
                  }
                }}
              />
            ))
          ) : (
            <></>
          )}
        </div>
        <div className="odds-block mob-view">
          <ExchOddBtn
            mainValue={
              ['7', '4339'].includes(eventData.sportId)
                ? 0
                : runner.layPrices[0]?.price
            }
            subValue={runner.layPrices[0]?.size}
            showSubValueinKformat={true}
            oddType="lay-odd"
            valueType="matchOdds"
            disable={isOddDisable(
              eventData,
              matchOddsData?.status?.toLowerCase(),
              matchOddsData.suspend,
              'lay',
              runner?.layPrices[0]?.price
            )}
            onClick={() => {
              if (
                moment(eventData?.openDate).diff(moment(), 'hour') <= 24 ||
                eventData?.status === 'IN_PLAY' ||
                disabledStatus.includes(matchOddsData.status.toLowerCase()) ||
                matchOddsData.suspend === true ||
                !['7', '4339'].includes(eventData.sportId)
              ) {
                setSelectedRow(runner.runnerId + marketName + 'MO');
                addExchangeBet({
                  sportId: eventData.sportId,
                  seriesId: eventData.competitionId,
                  seriesName: eventData.competitionName,
                  eventId: eventData.eventId,
                  eventName: eventData.eventName,
                  eventDate: eventData.openDate,
                  marketId: matchOddsData.marketId,
                  marketName: marketName,
                  marketType: 'MO',
                  outcomeId: runner.runnerId,
                  outcomeDesc: runner.runnerName,
                  betType: 'LAY',
                  amount: 0,
                  oddValue: runner.layPrices[0]?.price,
                  oddSize: runner.layPrices[0]?.size,
                  sessionPrice: -1,
                  srEventId: eventData.eventId,
                  srSeriesId: eventData.competitionId,
                  srSportId: eventData.sportId,
                  minStake: minStake,
                  maxStake: maxStake,
                  oddLimt: matchOddsData?.marketLimits?.maxOdd.toString(),
                  mcategory: 'ALL',
                });
              }
            }}
          />
        </div>
      </TableCell>
    </TableRow>
  );
};

const mapStateToProps = (state: RootState) => {
  const eventType = state.exchangeSports.selectedEventType;
  const competition = state.exchangeSports.selectedCompetition;
  const event = state.exchangeSports.selectedEvent;
  return {
    // eventData: getAllMarketsByEvent(
    //   state.exchangeSports.events,
    //   eventType.id,
    //   competition.id,
    //   event.id
    // ),
    // secondaryMatchOdds: getSecondaryMatchOddsByEvent(
    //   state.exchangeSports.secondaryMatchOddsMap,
    //   event.id
    // ),
    selectedEventType: eventType,
    bets: state.exchBetslip.bets,
    openBets: state.exchBetslip.openBets,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    addExchangeBet: (data: PlaceBetRequest) => dispatch(addExchangeBet(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MatchOddsTable);
